import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  RoleList: [],
  totalRole: 0,
  logsList: [],
  totalLogs: 0,
  permissionLogsList: [],
  totalPermissionLogs: 0,
  permissionList: [],
  totalPermission: 0,
  permissionMetaList: [],
  totalPermissionMeta: 0,
  permissionMetaLogsList: [],
  totalPermissionMetaLogs: 0,
};

const slice = createSlice({
  name: "permission",
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    // ---------- Roles ----------
    builder.addCase(Act.roleListApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.roleListApi.fulfilled, (state, action) => {
      state.RoleList = action.payload.data;
      state.totalRole = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.roleListApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.addRoleApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.addRoleApi.fulfilled, (state, action) => {
      state.RoleList = [action.payload.data, ...state.RoleList];
      state.totalRole += 1;
      state.loading = false;
    });
    builder.addCase(Act.addRoleApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.updateRoleApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.updateRoleApi.fulfilled, (state, action) => {
      state.RoleList = state.RoleList.map((item) =>
        item?._id === action.payload.data?._id
          ? { ...item, ...action.payload.data }
          : item,
      );
      state.loading = false;
    });
    builder.addCase(Act.updateRoleApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.deleteRole.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.deleteRole.fulfilled, (state, action) => {
      state.RoleList = state.RoleList.filter(
        (item) => item?._id !== action.payload.data?._id,
      );
      state.totalRole = Math.max(0, state.totalRole - 1);
      state.loading = false;
    });
    builder.addCase(Act.deleteRole.rejected, (state) => {
      state.loading = false;
    });

    // ---------- Role details / status change (logsList) ----------
    builder.addCase(Act.roleDetailsApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.roleDetailsApi.fulfilled, (state, action) => {
      state.logsList = action.payload.data;
      state.totalLogs = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.roleDetailsApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.statusChangeRoleApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.statusChangeRoleApi.fulfilled, (state, action) => {
      state.logsList = action.payload.data;
      state.totalLogs = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.statusChangeRoleApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.getActivePermissionList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.getActivePermissionList.fulfilled, (state, action) => {
      state.permissionList = action.payload.data;
      state.permissionLogsList = action.payload.data;
      state.totalPermission = action.payload.totalcount;
      state.totalPermissionLogs = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.getActivePermissionList.rejected, (state) => {
      state.loading = false;
    });

    // ---------- Permissions ----------
    builder.addCase(Act.permissionListApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.permissionListApi.fulfilled, (state, action) => {
      state.permissionList = action.payload.data;
      state.totalPermission = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.permissionListApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.addPermissionApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.addPermissionApi.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.addPermissionApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.updatePermissionApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.updatePermissionApi.fulfilled, (state, action) => {
      state.permissionList = state.permissionList.map((item) =>
        item?._id === action.payload.data?._id
          ? { ...item, ...action.payload.data }
          : item,
      );
      state.loading = false;
    });
    builder.addCase(Act.updatePermissionApi.rejected, (state) => {
      state.loading = false;
    });

    // ---------- Permission Meta (now uses its own state, not RoleList) ----------
    builder.addCase(Act.permissionMetaApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.permissionMetaApi.fulfilled, (state, action) => {
      state.permissionMetaList = action.payload.data;
      state.totalPermissionMeta = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.permissionMetaApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.addPermissionMetaApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.addPermissionMetaApi.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.addPermissionMetaApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.updatePermissionMetaApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.updatePermissionMetaApi.fulfilled, (state, action) => {
      state.permissionMetaList = state.permissionMetaList.map((item) =>
        item?._id === action.payload.data?._id
          ? { ...item, ...action.payload.data }
          : item,
      );
      state.loading = false;
    });
    builder.addCase(Act.updatePermissionMetaApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.deletePermissionMetaRole.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.deletePermissionMetaRole.fulfilled, (state, action) => {
      state.permissionMetaList = state.permissionMetaList.filter(
        (item) => item?._id !== action.payload.data?._id,
      );
      state.totalPermissionMeta = Math.max(0, state.totalPermissionMeta - 1);
      state.loading = false;
    });
    builder.addCase(Act.deletePermissionMetaRole.rejected, (state) => {
      state.loading = false;
    });

    // ---------- Permission Meta details / active list (own logs bucket) ----------
    builder.addCase(Act.permissionMetaDetailsApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.permissionMetaDetailsApi.fulfilled, (state, action) => {
      state.permissionMetaLogsList = action.payload.data;
      state.totalPermissionMetaLogs = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.permissionMetaDetailsApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.permissionMetaActiveListApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase( Act.permissionMetaActiveListApi.fulfilled, (state, action) => {
        state.permissionMetaLogsList = action.payload.data;
        state.totalPermissionMetaLogs = action.payload.totalcount;
        state.loading = false;
      },
    );
    builder.addCase(Act.permissionMetaActiveListApi.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default slice;